import { type CostsTotalCalculatorResponse } from './optionCostCalculator.util';

export type MembershipSavings = {
  membershipAdjustments: number;
  membershipAdjustmentsTax: number;
  membershipSavings: number;
};

type CostTotals = Pick<
  CostsTotalCalculatorResponse,
  'productsTotal' | 'productsTotalTax' | 'totalWithTax'
>;

export function resolveMembershipSavings(
  member: CostTotals,
  standard: CostTotals | undefined
): MembershipSavings {
  if (!standard) {
    return {
      membershipAdjustments: 0,
      membershipAdjustmentsTax: 0,
      membershipSavings: 0,
    };
  }

  return {
    membershipAdjustments: standard.productsTotal - member.productsTotal,
    membershipAdjustmentsTax:
      standard.productsTotalTax - member.productsTotalTax,
    membershipSavings: standard.totalWithTax - member.totalWithTax,
  };
}
